import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonLibComponent } from './common-lib.component';
import { CommonLibService } from './common-lib.service';
import { CarouselItemComponent } from './services/carousel-item.component';
import { CarouselItemDirective } from './services/carousel-item.directive';
import { TitleCasePipe } from './services/title-case.pipe';
import { SwipeDirective } from './services/swipe.directive';
import { MyCurrencyPipe } from './services/currency.pipe';
import { ConverterPipe } from './services/converter.pipe';
import { SlideNavDirective } from './services/slide-nav.directive';
import { SwipeLeftDirective } from './services/swipe-left.directive';
import { HttpClientModule } from '@angular/common/http';
// import { CommonModule } from '@angular/common';
import { ScrollService } from './services/scroll.service';
import { VideoPipe } from './services/video.pipe';


@NgModule({
  declarations: [CommonLibComponent, CarouselItemComponent, CarouselItemDirective, TitleCasePipe, SwipeDirective, MyCurrencyPipe, ConverterPipe, SlideNavDirective,
                 SwipeLeftDirective, SwipeDirective, VideoPipe  ],
  imports: [
    // CommonModule,
    HttpClientModule
  ],
  exports: [CommonLibComponent, CarouselItemComponent, CarouselItemDirective, TitleCasePipe, SwipeDirective, MyCurrencyPipe, ConverterPipe, SlideNavDirective,
           SwipeLeftDirective, SwipeDirective, VideoPipe  ],
  providers: [ ScrollService, ConverterPipe ],
  
})
export class CommonLibModule { 
  public static forRoot(environment: any): ModuleWithProviders<any> {

    return {
      ngModule: CommonLibModule,
      providers: [
        CommonLibService,
        {
          provide: 'environment', // you can also use InjectionToken
          useValue: environment
        }
      ]
    };
  }
}
